import React from "react";
import { useTranslation } from "react-i18next";

import { HOME_FEATURE_IMAGES } from "../../content/home";
import useInView from "../../hooks/useInView";
import { MAIN_ROUTES } from "../../utils/routes";

const Features = () => {
  const { t } = useTranslation("home");
  const [setRef, visible] = useInView({
    threshold: 0.07,
  });
  const featureItems = t("features.items", { returnObjects: true }).map(
    (item, index) => ({
      ...item,
      image: HOME_FEATURE_IMAGES[index],
    }),
  );

  return (
    <section
      className="relative overflow-hidden bg-sky-50 py-24"
      id={MAIN_ROUTES.get("FEATURES").ID}
    >
      <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(255,255,255,0.4),rgba(217,231,255,0.95))]" />
      <div className="relative mx-auto flex max-w-8xl flex-col gap-14 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto flex max-w-3xl flex-col items-center gap-6 text-center">
          {t("features.subheader") ? (
            <p className="text-sm font-semibold uppercase tracking-[0.22em] text-sky-600">
              {t("features.subheader")}
            </p>
          ) : null}
          <h2 className="text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
            {t("features.header")}
          </h2>
          <p className="text-base leading-8 text-slate-600 sm:text-lg">
            {t("features.body")}
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 xl:grid-cols-4" ref={setRef}>
          {featureItems.map((item, index) => (
            <article
              className={`rounded-2xl border border-white/70 bg-white/80 px-7 py-8 shadow-[0_24px_60px_rgba(37,43,129,0.08)] backdrop-blur-sm transition duration-500 ${
                visible
                  ? "translate-y-0 opacity-100"
                  : "translate-y-6 opacity-0"
              }`}
              key={item.header}
              style={{ transitionDelay: `${index * 120}ms` }}
            >
              <div className="mb-8 flex h-16 w-16 items-center justify-center rounded-2xl bg-[linear-gradient(135deg,#00d2ff_0%,#3a47d5_100%)] p-4 shadow-lg shadow-sky-200/70">
                <img
                  alt={item.header}
                  className="h-full w-full object-contain brightness-[4] grayscale"
                  src={item.image}
                />
              </div>
              <div className="space-y-3">
                <h3 className="text-xl font-semibold tracking-tight text-slate-900">
                  {item.header}
                </h3>
                <p className="text-sm leading-7 text-slate-600 sm:text-base">
                  {item.content}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Features;
